import React from 'react'
import { Link } from 'gatsby'
import { Box, Grid } from 'grommet'

import Layout from '../../components/layout'
import SEO from '../../components/seo'
import ProductNav from '../../components/ProductNav'
import FormArtFiles from '../../components/FormArtFiles'

const PostcardsDesign = () => (
  <Layout productNav="postcards">
    <SEO title="Postcards - Design" />
    <Box pad={{ vertical: 'medium' }} fill>
      <FormArtFiles product="postcards" />
    </Box>
  </Layout>
)

export default PostcardsDesign
